const primaryRed = "#8C1614";
const darkRed = "#6A0B09";
const black = "#000000";
const white = "#FFFFFF";

///verificar-conta////
export const containerStyle = {
  w: "fit-content",
  mt: 10,
  bg: "gray.50",
  borderRadius: "2xl",
  boxShadow: "md",
  direction: "column",
  maxWidth: "900px",
}

export const primaryButton = {
  fontSize: "md",
  fontWeight: "bold",
  color: "white",
  bg: "red.700",
  p: 4,
  transition: "transform 0.2s ease-in-out",
  _hover: { transform: "scale(1.02)", bg: "red.600" },
  boxShadow: "sm",
}

export const secondaryButton = {
  fontSize: "md",
  fontWeight: "bold",
  color: "#333333",
  bg: "transparent",
  border: "none",
  p: 5,
  w: "auto",
  transition: "transform 0.2s ease-in-out",
  _hover: { transform: "scale(1.02)" },
  boxShadow: "sm",
}
//////////////
// INPUT
export const inputStyle = {
  _placeholder: { color: 'gray.400' },
  color: 'gray.700',
  bg: 'white',
  border: '1px solid',
  borderColor: 'gray.300',
  rounded: 'xl',
  transition: 'all 0.2s ease-in-out',
}

////INPUT COM SEARCH JUNTO
export const inputSearchStyle = {
  input: {
    _focus: { bg: "gray.100", outline: "none" },
    _placeholder: { color: "gray.400" },
    flex: "1",
    w: "100%",
    borderEndRadius: "none",
    borderStartRadius: "lg",
    color: "black",
    border: "none",
    boxShadow: "sm",
    bg: "white",
  },
  button: {
    border: "none",
    bg: "red-wine",
    color: "white",
    _hover: { bg: "red.500" },
    borderEndRadius: "lg",
    borderStartRadius: "none",
    fontWeight: "bold",
    boxShadow: "sm",
  },
  sendButtonFlex: {
    align: "center",
    justify: "center",
    color: ["gray.800", "white"],
    borderRadius: "xl",
    boxShadow: "sm",
    px: "8",
    fontWeight: "bold",
    cursor: "pointer",
    alignSelf: "stretch",
    transition: "all 0.4s ease",
    _hover: {
      boxShadow: "lg",
      transform: "scale(1.02)",
      bg: ["gray.100", "red.500"],
    }
  },
  sendButton: {
    bg: "transparent",
    color: ["gray.800", "white"],
    transition: "all 0.4s ease",
  }
}

/////////newsletter section
export const newsletterStyles = {
  sectionContainer: {
    bg: "#6A0B09",
    py: 6,
    px: ["4", "20"],
    boxShadow: "0 -2px 6px rgba(0, 0, 0, 0.3), 0 4px 8px rgba(0, 0, 0, 0.3)",
  },
  contentWrapper: {
    direction: "column",
    align: "center",
    justify: "center",
    lineHeight: "2rem",
    p: "0",
    gap: ["5", "10"],
  },
  titleTextStyle: {
    fontSize: ["2xl", "3xl"],
    fontWeight: "bold",
    color: "white",
    textAlign: "center",
    fontFamily: "merriweather"
  },
  div: {
    height: '3px',
    width: '100%',
    backgroundColor: '#a81a18ff',
    borderRadius: 'full',
    mt: "2"
  },
  titleDescriptionStyle: {
    fontSize: "xl",
    fontWeight: "bold",
    color: "gray.300",
    textAlign: "center",
    mt: "2"
  },
  inputsFlex: {
    bg: "red-wine",
    p: "4",
    boxShadow: "sm",
    borderRadius: "xl",
    w: "100%",
    gap: "6",
    direction: ["column", "row"],
    mb: "4"
  },
  inputWrapper: {
    borderRadius: "lg",
    w: "full",
  },
  labelTitle: {
    border: "none",
    bgGradient: "to-b",
    gradientFrom: "white",
    gradientTo: "gray.300",
    borderEndRadius: "none",
    borderStartRadius: "lg",
    fontWeight: "400",
    boxShadow: "sm",
    fontSize: "sm",
    px: ["2", "10"],
    position: "relative",
    zIndex: "2",
    alignItems: "center",
  },
  inputBox: {
    _focus: { bg: "gray.100", outline: "none" },
    _placeholder: { color: "gray.400" },
    flex: "1",
    w: "100%",
    borderEndRadius: "lg",
    borderStartRadius: "none",
    color: "black",
    border: "none",
    boxShadow: "sm",
    bg: "white",
  },
};
////////////

export const setedigitalFooterStyles = {
  footerContainerStyle: {
    direction: "column",
    align: "center",
    textAlign: "center",
    bg: "#6A0B09",
    // borderTop: "1px solid white",
    py: 1,
    zIndex: "10",
    position: "relative"
  },
  desktopTextStyle: {
    fontSize: "sm",
    color: "gray.300",
    pb: "6",
    display: ["none", "block"]
  },
  mobileTextStyle: {
    color: "gray.200",
    fontSize: "sm",
    display: ["block", "none"],
    pb: "10",
  },
  logoStyle: {
    src: `/images/logos/SeteDigitalLogo.webp`,
    alt: "Sete Digital",
    maxWidth: ["40%", "10%"],
    h: "auto",
    transition: "all 0.3s ease",
    _hover: {
      transform: "scale(1.1)",
    }
  }
}

/////
export const instagramCarouselStyles = {
  carouselContainer: {
    position: "relative",
    width: "100%",
    mx: "auto",
    py: 4,
  },
  sliderContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: {
      base: "0.75rem",
      md: "0.75rem",
      lg: "0.85rem",
      xl: "1rem",
    },
    padding: "0.5rem",
  },
  navButton: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 10,
    borderRadius: "full",
    bg: "red-wine",
    color: "white",
    _hover: { bg: 'red.600' },
    boxShadow: "sm",
  },
  leftNavButton: {
    display: "none",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 10,
    left: { base: -5, md: -10 },
  },
  rightNavButton: {
    display: "none",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 10,
    right: { base: -5, md: -10 },
  },
  carouselWrapper: {
    width: "100%",
    overflow: "hidden",
  },
  slideFlex: {
    justify: "center",
    align: "center",
    w: "full",
    h: "200px",
    p: "0",
  },
  slideImage: {
    objectFit: "cover",
    transition: "transform 0.3s ease",
    _hover: { transform: 'scale(1.1)' },
  },
  sectionContainer: {
    pb: "8",
    py: 8,
    bg: "#F4F4F4",
    width: "100vw",
    position: "relative",
    left: "50%",
    right: "50%",
    marginLeft: "-50vw",
    marginRight: "-50vw",
    marginTop: [4],
  },
  headerFlex: {
    direction: "column",
    align: ["center", "start"],
    mb: 6,
  },
  headerTitle: {
    fontSize: ["2xl", "4xl"],
    fontWeight: "bold",
    mb: 1,
    textAlign: ["center", "start"],
    color: "black",
    fontFamily: "merriweather",
  },
  headerDivider: {
    display: ['none'],
    width: "8%",
    height: "4px",
    bg: "red-wine",
    borderRadius: "full",
  },
  feedSeeMore: {
    padding: "10px",
    bg: primaryRed,
    borderRadius: "8px",
    color: white,
    fontFamily: "system-ui, sans-serif",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "150px",
    height: "50px",
    _hover: {
      bg: "red.600",
      transform: "translateY(-2px)",
      boxShadow: "lg",
    },
    _active: {
      bg: darkRed,
      transform: "translateY(0)",
    },
    transition: "all 0.3s ease",
    cursor: "pointer",
  },
};

//////////ASSOCIATE CHECK
export const associateCheck = {
  flexContainer: {
    align: "center",
    justify: "center",
    px: "4",
    py: "20",
  },
  boxContainer: {
    maxW: "600px",
    w: "100%",
    bg: "white",
    borderRadius: "8px",
    boxShadow: "md",
    textAlign: "center",
    fontFamily: "system-ui, sans-serif",
    color: "gray.800",
  },
  heading: {
    fontSize: "2xl",
    color: "white",
    mb: 2,
    bg: "red-wine",
    p: "4",
    boxShadow: "md",
    borderTopRadius: "lg",
  },
  description: {
    mb: 4,
    mt: "4",
    color: "gray.600",
    fontSize: "md",
  },
  contentStack: {
    px: "10",
    py: "2"
  },
  inputField: {
    maxLength: 8,
    fontSize: "1.5rem",
    p: 2,
    textAlign: "center",
    borderRadius: "4px",
    border: "1px solid",
    borderColor: "gray.300",
    bg: "white",
    placeholder: "Digite o código",
  },
  pdfButton: {
    color: "black",
    bg: "white",
    fontWeight: "bold",
    boxShadow: "0px 2px 4px color-mix(in srgb, black 64%, transparent),0px 0px 1px inset color-mix(in srgb, var(--chakra-colors-gray-300) 30%, transparent)",
    transition: "all 0.3s ease",
    _hover: { bg: "red-wine", color: "white", transform: "scale(1.02)" }
  }
};

/////EMAIL////
export const emailChangeStyles = {
  grid: {
    columns: [1, 2],
    gap: 6,
    mt: 6,
  },
  mainFlex: {
    minH: "100vh",
    w: "100%",
    bg: "gray.100",
    align: "center",
    justify: "center",
    backgroundImage: "url('/images/logos/aajumpLogo.webp')",
    backgroundRepeat: "repeat",
    backgroundSize: "400px",
    backgroundPosition: "top left",
    direction: "column",
    px: ["4", "0"],
  },
  avatarFlex: {
    gap: "6",
    bg: "gray.100",
    px: "8",
    py: "2",
    borderRadius: "lg",
    boxShadow: "sm",
    w: "fit-content",
    mb: "8",
  },
  logoutFlex: {
    align: "center",
    gap: "1",
    fontSize: "sm",
    color: "gray.600",
    cursor: "pointer",
    _hover: {
      color: "red.500",
      cursor: "pointer",
    },
  },
  formContent: {
    bg: "white",
    borderRadius: "lg",
    boxShadow: "md",
    color: "gray.700",
    maxWidth: "900px",
    w: "100%",
  },
  titleFlex: {
    bg: "red-wine",
    p: 2,
    color: "white",
    fontSize: "xl",
    position: "relative",
    zIndex: 10,
    fontWeight: "bold",
    textAlign: "center",
    borderTopRadius: "lg",
    justifyContent: "center",
    boxShadow: "sm",
    w: "100%",
  },
  infoFlex: {
    align: "center",
    bg: "gray.100",
    p: "3",
    borderRadius: "md",
    mb: "6",
    gap: "2",
  },
  sendButton: {
    bg: "green",
    color: "white",
    boxShadow: "md",
    transition: "all 0.4s ease",
    borderRadius: "xl",
    _hover: {
      transform: "scale(1.06)",
      backgroundColor: "green.600",
    },
  },
  returnButton: {
    bg: "red-wine",
    color: "white",
    boxShadow: "sm",
    transition: "all 0.4s ease",
    borderRadius: "xl",
    _hover: {
      transform: "scale(1.06)",
      backgroundColor: "red.600",
    },
  },
  returnButton2: {
    bg: "white",
    color: "black",
    boxShadow: "sm",
    transition: "all 0.4s ease",
    borderRadius: "xl",
    _hover: {
      transform: "scale(1.06)",
      backgroundColor: "gray.200",
    },
  },
};

export const DocumentationStyles = {
  boxContainer: {
    px: ["4", "10", "20"],
    mt: "20",
  },
  mainFlex: {
    direction: "column",
    alignItems: "flex-start",
    gap: [8, 20],
  },
  content: {
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: 2,
  },
};